import axios from "axios";
import { ElMessage, ElSkeleton } from "element-plus";
import { ref } from "vue";
import { mapMutations, mapState } from "vuex";
import OouiSuccess from "~icons/ooui/success";
import LineMdSunnyOutlineToMoonLoopTransition from '~icons/line-md/sunny-outline-to-moon-loop-transition';
import LineMdMoonToSunnyOutlineLoopTransition from '~icons/line-md/moon-to-sunny-outline-loop-transition';
export default {
  data() {
    return {
      dialogVisible: false,
      loadingFetch: false,
      loadingUser: false,
      themeLocal: false,
      items: [{
        title: "История заказов",
        path: "/rol-shop/profile/history",
        imgUrl: require("@/img/icon/history.svg")
      }, {
        title: "Избранные товары",
        path: "/rol-shop/profile/favorites",
        imgUrl: require("@/img/icon/heart.svg")
      }, {
        title: "Адрес доставки",
        path: "/rol-shop/profile/address",
        imgUrl: require("@/img/icon/address.svg")
      }],
      OouiSuccess: OouiSuccess
    };
  },
  components: {
    ElSkeleton,
    LineMdSunnyOutlineToMoonLoopTransition,
    LineMdMoonToSunnyOutlineLoopTransition
  },
  computed: {
    ...mapState({
      theme: state => state.theme.theme
    })
  },
  methods: {
    ...mapMutations({
      setTheme: "theme/setTheme"
    }),
    async fetchUser() {
      try {
        this.loadingUser = true;
        const {
          data
        } = await axios.get(`https://c2ff7a8de0a119c8.mokky.dev/users`);
        this.user = data[0];
        this.form.name = this.user.name;
        this.form.email = this.user.email;
      } catch (err) {
        console.log(err);
      } finally {
        this.loadingUser = false;
      }
    },
    async saveChanges() {
      try {
        this.loadingFetch = true;
        await axios.delete(`https://c2ff7a8de0a119c8.mokky.dev/users/${this.user.id}`);
        const {
          data
        } = await axios.post(`https://c2ff7a8de0a119c8.mokky.dev/users`, {
          name: this.form.name,
          email: this.form.email,
          tel: "89534133883"
        });
      } catch (err) {
        console.log(err);
      } finally {
        this.dialogVisible = false;
        this.loadingFetch = false;
        this.fetchUser();
        this.message("Данные обновлены");
      }
    },
    submitForm() {
      this.ruleFormRef.validate(valid => {
        if (valid) {
          this.saveChanges();
        } else {
          return false;
        }
      });
    },
    cancelChanges() {
      this.dialogVisible = false;
      this.form.name = this.user.name;
      this.form.email = this.user.email;
    },
    changeTheme() {
      this.themeLocal = !this.theme;
      this.setTheme(this.themeLocal);
      if (this.themeLocal) {
        document.body.classList.add("dark");
      } else {
        document.body.classList.remove("dark");
      }
    },
    message(text) {
      ElMessage({
        message: text,
        type: "success",
        icon: this.OouiSuccess
      });
    }
  },
  mounted() {
    this.fetchUser();
  },
  setup(props) {
    const user = ref("");
    const ruleFormRef = ref({});
    const form = ref({
      name: "",
      email: "",
      type: []
    });
    const rules = ref({
      name: [{
        required: true,
        message: "Нужно заполнить!",
        trigger: ["blur", "change"]
      }, {
        min: 3,
        message: "Слишком короткий!",
        trigger: ["blur", "change"]
      }],
      email: [{
        required: true,
        message: "Нужно заполнить!",
        trigger: "blur"
      }, {
        type: "email",
        message: "Некорректный email!",
        trigger: ["blur", "change"]
      }],
      type: [{
        type: "array",
        required: true,
        message: "Нужно отметить!",
        trigger: "change"
      }]
    });
    return {
      ruleFormRef,
      form,
      rules,
      user
    };
  }
};